import { render, staticRenderFns } from "./SearchProject.vue?vue&type=template&id=12918ed6&scoped=true"
import script from "./SearchProject.vue?vue&type=script&lang=ts"
export * from "./SearchProject.vue?vue&type=script&lang=ts"
import style0 from "./SearchProject.vue?vue&type=style&index=0&id=12918ed6&prod&lang=scss&scoped=true"
import style1 from "./SearchProject.vue?vue&type=style&index=1&id=12918ed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12918ed6",
  null
  
)

export default component.exports